export function isPrerendering(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  const w = window as any;
  const ua = navigator.userAgent || '';

  return Boolean(
    w.__REACT_SNAP__ ||
    w.phantom ||
    ua.includes('ReactSnap') ||
    ua.includes('jsdom')
  );
}


